import { render } from "./checkmark_v4.svg?vue&type=template&id=38a0d7ea&inline"
const script = {}

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__